import Icon from 'components/Icon';
import TextLoadingWrapper from 'components/TextLoadingWrapper';
import { getArticle } from 'constants/helpCenter';
import WithScroll from 'hocs/WithScroll';
import { trimName } from '../../../utils';
import { ROOT } from '../../../constants';

const CollectionItem = ({
  collection,
  history,
  scroll: { triggerScrolling },
}) => {
  const {
    firstArticle: { id: newArticleId, slug: newArticleSlug } = {},
    id = 0,
    name,
    icon,
    description,
    slug,
  } = collection;

  const boxStyles = !id ? { cursor: 'wait' } : {};

  const goToArticle = () => {
    if (!newArticleId) return;

    getArticle(newArticleId).then(({ data: { article } }) => {
      history.push(`${ROOT}/${slug.split('icon')[0]}/${newArticleSlug}`, {
        article: {
          ...article,
          categoryId: article.categories[0],
        },
        collectionid: id,
        collectionName: trimName(name),
      });
      triggerScrolling();
    });
  };

  const handleClick = () => {
    if (!id) return;

    goToArticle();
  };

  return (
    <div className="col col-4 col-phone-12 section__col">
      <div onClick={handleClick} className="section__box" style={boxStyles}>
        <div className="section__icon-wrap _mb-20">
          <TextLoadingWrapper condition={!!id} animationClass="text-animation">
            {id ? (
              <Icon className="section__icon" icon={icon} />
            ) : (
              <i className="section__icon" />
            )}
          </TextLoadingWrapper>
        </div>
        <TextLoadingWrapper condition={!!id} animationClass="text-animation">
          <h3 className="title section__title _mb-20 _capitalize">
            {!!id && name}
          </h3>
          <p className="text section__text">{!!id && description}</p>
        </TextLoadingWrapper>
      </div>
    </div>
  );
};

export default WithScroll(CollectionItem);
